export const getDoneOrders = state => state.orders.ordersDone
export const getPendingOrders = state => state.orders.ordersPending
export const getOrderWindowNames = state => state?.orders?.orderWindowNames ?? {}
